import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { ColorOptions, HorizontalAlignmentOptions, HtmlTagOptions, TextStyleOptions } from '@df/ui/atomic/atomic-options';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { ICmsClientModule } from '@icms/client/icms-client.module';

export namespace NCmsText {
    export const componentId = 'text';

    export interface IComponentData extends NICmsContentComponent.IData {
        text: string;
        tag?: string;
        align?: string;
        style?: string;
        color?: string;
    }
}

@ICmsComponent<CmsTextComponent>({
    id: NCmsText.componentId,
    name: 'Text',
    tags: ['Content', 'Text'],
    isAdvanced: true,
    fields: [
        <NICmsContentField.IChoiceField>{
            key: 'style',
            type: NICmsContentField.EFieldType.choice,
            title: 'Text Style',
            options: TextStyleOptions,
            default: 'h2'
        },
        {
            key: 'text',
            type: NICmsContentField.EFieldType.textarea,
            title: 'Copy',
            description: 'Text to display. HTML code can be used.',
            default: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
            required: true
        },
        <NICmsContentField.IChoiceField>{
            key: 'align',
            type: NICmsContentField.EFieldType.choice,
            title: 'Text Alignment',
            options: HorizontalAlignmentOptions,
            default: 'center'
        },
        <NICmsContentField.IChoiceField>{
            key: 'color',
            type: NICmsContentField.EFieldType.choice,
            colorPreview: true,
            title: 'Text Color',
            options: ColorOptions,
            default: 'col-1'
        },
        {
            key: 'tag',
            type: NICmsContentField.EFieldType.choice,
            title: 'HTML Tag',
            description: 'For SEO reasons you may want to force particular HTML tag',
            options: HtmlTagOptions,
            default: 'p'
        }
    ],
    priority: 20
})
@Component({
    selector: 'cms-text',
    templateUrl: './cms-text.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsTextComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: NCmsText.IComponentData;
}
